import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import { Buffer } from 'buffer';
import './index.css';
import App from './App';

// Polyfill Buffer for browser environment (needed for qrcode library in production)
if (typeof window !== 'undefined') {
  window.Buffer = window.Buffer || Buffer;
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <App />
    </Router>
  </React.StrictMode>
);